import { Children } from 'react';
import componentName from './componentName';
import { isSeries } from './componentIsX';
export default function collectDataFromChildSeries(children) {
  var allRawData = [];
  var allBinnedData = [];
  var rawDataByIndex = {};
  var binnedDataByIndex = {};
  Children.forEach(children, function (Child, i) {
    var name = componentName(Child);

    if (isSeries(name)) {
      var rawData = Child.props.rawData;
      var binnedData = Child.props.binnedData;

      if (rawData && rawData.length > 0) {
        rawDataByIndex[i] = rawData;
        allRawData = allRawData.concat(rawData);
      }

      if (binnedData && binnedData.length > 0) {
        binnedDataByIndex[i] = binnedData;
        allBinnedData = allBinnedData.concat(binnedData);
      }
    }
  });
  return {
    allBinnedData: allBinnedData,
    allRawData: allRawData,
    binnedDataByIndex: binnedDataByIndex,
    rawDataByIndex: rawDataByIndex
  };
}